
import { defineComponent, PropType, computed } from "vue";
import { IndicatorGroup, externalLink } from "./trf";

export default defineComponent({
  name: "IndicatorGroups",
  props: {
    groups: {
      type: Array as PropType<IndicatorGroup[]>,
      required: true,
    },
    // When collapsed, only the first few groups (CVEs/IOCs first) are shown.
    collapsed: {
      type: Boolean,
      default: false,
    },
    previewCount: {
      type: Number,
      default: 3,
    },
  },
  emits: ["filter", "expand"],
  setup(props) {
    const visibleGroups = computed(() =>
      props.collapsed ? props.groups.slice(0, props.previewCount) : props.groups
    );
    return { visibleGroups, externalLink };
  },
});
